import s from './contacts.module.css';

const Contacts = () => {
  return (
    <div className={s.container}>
      <ul className={s.list}>
        <li className={s.item}>
          <a className={s.linc} href="https://goo.gl/maps/kpUELzdVmnC4goEU7">
            вулиця Богдана Хмельницького, 52-Б, Київ, 01030
          </a>
        </li>
        <li className={s.item}>
          <a className={s.linc} href="mailto:info@gamepro.com">
            info@gamepro.com
          </a>
        </li>
        <li className={s.item}>
          <a className={s.linc} href="tel:+380507746246">
            +38 (050) 774 62 46
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Contacts;
